import Home from './Home.vue';

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home/index.js